import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { login } from '../../services/authService';

// Async thunk for logging in user
export const loginUser = createAsyncThunk('auth/login', async (credentials, thunkAPI) => {
    try {
        const response = await login(credentials);
        const data = response.data;
        const { token, user } = data;
        
        // Store user & token in localStorage
        localStorage.setItem('user', JSON.stringify(user)); // Convert user to JSON string
        localStorage.setItem('token', token); 

        return data;
    } catch (error) {
        console.log('Login Reject:', error.response);
        return thunkAPI.rejectWithValue(error.response.data);
    }
});

// Get initial state from localStorage if available
const initialState = {
    user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null,
    token: localStorage.getItem('token') || null,
    loading: false,
    error: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logout(state) {
            state.user = null;
            state.token = null;
            // Clear user & token on logout
            localStorage.removeItem('user');
            localStorage.removeItem('token');  
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(loginUser.fulfilled, (state, action) => {
                state.loading = false;
                state.user = action.payload.user;
                state.token = action.payload.token;
            })
            .addCase(loginUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;


